// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__COX8y","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1Tmam"};